<template>
    <div class="content-wrapper">
        <div class="d-flex justify-content-between">
            <app-breadcrumb :page-title="$t('manage_notifications')"/>
            <div class="col-sm-12 col-md-6 breadcrumb-side-button text-right pr-0">
                <button class="btn btn-primary"
                        data-toggle="modal"
                        @click="openAddModal()">
                    <app-icon name="plus" class="mr-1"/>
                    {{ $t('add') }}
                </button>
            </div>
        </div>
        <div class="border-0">
            <div class="position-relative" style="min-height: 400px;"
                 :class="{'loading-opacity':NotificationsViewLoader}">
                <app-overlay-loader v-if="NotificationsViewLoader"/>
                <div v-else class="notifications-wrapper custom-scrollbar overflow-auto"
                     style="min-height: 400px"
                     :class="{'justify-content-center align-items-center': !NotificationsViewData.data.length}">
                    <template v-if="NotificationsViewData.data.length">
                        <div class="notifications-column">
                            <div class="card card-with-shadow mb-2 border-0 draggable-item"
                                    v-for="(element, index) in NotificationsViewData.data"
                                    :key="index">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-10">
                                            <div class="media d-flex align-items-start mb-primary">
                                                <app-avatar :title="element.name"
                                                            class="mr-2"
                                                            avatar-class="avatars-w-20"
                                                            :img="element.img?element.img:''"
                                                            :alt-text="$t('not_found')"/>
                                                <div class="media-body d-flex justify-content-start">
                                                    <span v-if="element.enabled == 0" class="badge badge badge-warning badge-sm badge-pill mx-2">{{ $t('disabled') }}</span>
                                                    <span v-if="element.enabled == 2" class="badge badge badge-info badge-sm badge-pill mx-2">{{ $t('updates_only') }}</span>
                                                    <span>{{ element.name }}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-2 text-right">
                                            <div class="dropdown options-dropdown d-inline-block">
                                                <button type="button" class="btn-option btn" data-toggle="dropdown"
                                                        :title="$t('actions')">
                                                    <app-icon name="more-vertical"/>
                                                </button>
                                                <div class="dropdown-menu dropdown-menu-right py-2 mt-1">
                                                    <a class="dropdown-item px-4 py-2"
                                                        @click="editItem(element.id)"
                                                        href="#">
                                                        {{ $t('edit') }}
                                                    </a>
                                                    <a class="dropdown-item px-4 py-2"
                                                        @click="deleteItem(element.id)"
                                                        href="#">
                                                        {{ $t('delete') }}
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="text-muted d-flex align-items-center justify-content-between">
                                        <div class="media d-flex align-items-center">
                                            <div class="media-body">
                                                <div v-if="element.teams != null && element.teams.length > 0" class="mb-2">
                                                    <div><span><b>{{ $t('teams') }}</b></span></div>
                                                    <span
                                                        v-for="(team, team_index) in element.teams"
                                                        :key="team_index">
                                                        {{ team.parent.name }},
                                                    </span>
                                                </div>
                                                <div v-if="element.leagues != null && element.leagues.length > 0" class="mb-2">
                                                    <div><span><b>{{ $t('leagues') }}</b></span></div>
                                                    <span
                                                        v-for="(league, league_index) in element.leagues"
                                                        :key="league_index">
                                                        {{ league.parent.name }},
                                                    </span>
                                                </div>
                                                <div v-if="element.sport != null" class="mb-2">
                                                    <div><span><b>{{ $t('sport') }}</b></span></div>
                                                    <span>
                                                        {{ $t(element.sport) }}
                                                    </span>
                                                </div>
                                                <div v-if="element.conditions != null && element.conditions.length > 0" class="mb-2">
                                                    <div><span><b>{{ $t('conditions') }}</b></span></div>
                                                    <div
                                                        v-for="(condition, condition_index) in element.conditions"
                                                        :key="condition_index">
                                                        <template v-if="condition.condition == 'market' || condition.condition == 'sub_market'">
                                                            {{ $t(condition.condition) }}: {{ $t(condition.value) }}
                                                        </template>
                                                        <template v-else>
                                                            {{ $t(condition.condition) }} {{ condition.equation }} {{ condition.value }} <template v-if="condition.percent === 1">%</template>
                                                        </template>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <app-empty-data-block :message="$t('nothing_to_show_here')"></app-empty-data-block>
                    </template>

                </div>
            </div>
        </div>

        <!--Add Edit Modal-->
        <notifications-add-edit-modal v-if="isTaskModalActive"
            modal-id="notifications-view-add-edit-modal"
            :selected-id="selectedId"
            :selected-url="selectedUrl"
            @afterSubmitDone="reloadAllState"
            @close-modal="isTaskModalActive=false"/>
        <!--Delete Modal-->
        <app-delete-modal v-if="deleteConfirmationModalActive"
            :preloader="deleteLoader"
            :selected-id="selectedId"
            modal-id="notification-delete"
            @confirmed="confirmed"
            @cancelled="canceled"/>
    </div>
</template>

<script>
import draggable from 'vuedraggable';
import CoreLibrary from "../../../../../core/helpers/CoreLibrary";
import * as actions from "../../../../Config/ApiUrl";

export default {
    name: "NotificationsView",
    components: {draggable},
    extends: CoreLibrary,
    data() {
        return {
            NotificationsViewLoader: false,
            deleteLoader: false,
            isTaskModalActive: false,
            deleteConfirmationModalActive: false,
            NotificationsViewData: [],
            selectedUrl: null,
            selectedId: null,
            deletedTaskId: null,
        };
    },
    created() {
        this.reloadNotificationsView();
    },
    methods: {
        reloadNotificationsView() {
            this.NotificationsViewLoader = true;
            this.axiosGet(actions.MANAGE_NOTIFICATION_ALL).then(res => {
                this.NotificationsViewData = res.data;
            }).finally(() => this.NotificationsViewLoader = false);
        },
        openAddModal() {
            this.selectedUrl = '';
            this.selectedId = null;
            this.isTaskModalActive = true;
        },
        reloadAllState() {
            this.selectedUrl = '';
            this.selectedId = null;
            this.isTaskModalActive = false;
            this.reloadNotificationsView();
        },
        editItem(notificationId) {
            this.selectedUrl = `${actions.MANAGE_NOTIFICATION_EDIT}/${notificationId}`;
            this.selectedId = notificationId;
            this.isTaskModalActive = true;
        },
        deleteItem(notificationId) {
            this.deletedTaskId = notificationId;
            this.deleteConfirmationModalActive = true
        },
        confirmed() {
            this.deleteLoader = true;
            this.axiosDelete(`${actions.MANAGE_NOTIFICATION_DELETE}/${this.deletedTaskId}`)
                .then((res) => {
                    this.hideDeleteModal();
                    this.$toastr.s(this.$t('notification_deleted'));
                    this.reloadNotificationsView();
                })
                .catch(err => {
                    this.hideDeleteModal();
                    this.$toastr.e(this.$t('something_went_wrong'));
                })
        },
        hideDeleteModal() {
            this.deleteLoader = false;
            $("#notification-delete").modal('hide');
            this.canceled();
        },
        canceled() {
            this.deletedTaskId = null;
            this.deleteConfirmationModalActive = false;
        }
    }
}
</script>
